import { IconButton, Menu, MenuGroup, MenuItem, useTranslate } from '@prenuvo/halo';
import { ArrowUpright, Settings } from '@prenuvo/halo-icon';

import { useIsDDFeatureFlagEnabled } from '@/core/data-dog';
import { useReportIssue } from '@/core/report-issue';

import { EllipsisSvg } from './ellipses-svg.component';
import { FCT_GUIDE_URL } from './header-menu.constant';

interface HeaderMenuProps {
  onOpenActivityLogs: () => void;
  onOpenPreferences: () => void;
}

export function HeaderMenu({ onOpenActivityLogs, onOpenPreferences }: HeaderMenuProps) {
  const { onToggleReportIssue } = useReportIssue();
  const translate = useTranslate();

  const isUserPreferencesEnabled = useIsDDFeatureFlagEnabled('FCT_USER_PREFERENCES');

  const menuIcon = isUserPreferencesEnabled ? Settings : EllipsisSvg;

  return (
    <Menu
      className={{ content: 'dark:bg-fct-container dark:border-neutral-850' }}
      trigger={
        <IconButton
          aria-label={translate('FCT.REPORTING.HEADER.MENU.TRIGGER')}
          icon={menuIcon}
          size="sm"
          variant="text"
        />
      }
    >
      <MenuGroup>
        <MenuItem
          className={{
            root: 'hover:dark:bg-neutral-850 hover:dark:border-neutral-850 cursor-pointer',
          }}
          onSelect={onOpenActivityLogs}
          translationKey="FCT.REPORTING.HEADER.MENU.ACTIVITY_LOG"
        />

        <MenuItem
          className={{
            root: 'hover:dark:bg-neutral-850 hover:dark:border-neutral-850 cursor-pointer',
          }}
          onSelect={() => globalThis.open(FCT_GUIDE_URL, '_blank', 'noopener,noreferrer')}
          rightIcon={ArrowUpright}
          translationKey="FCT.REPORTING.HEADER.MENU.FCT_GUIDE"
        />

        {isUserPreferencesEnabled && (
          <MenuItem
            className={{
              root: 'hover:dark:bg-neutral-850 hover:dark:border-neutral-850 cursor-pointer',
            }}
            onSelect={onOpenPreferences}
            translationKey="FCT.REPORTING.HEADER.MENU.PREFERENCES"
          />
        )}

        <MenuItem
          className={{
            content: 'w-full',
            root: 'hover:dark:bg-neutral-850 hover:dark:border-neutral-850 cursor-pointer',
          }}
          onSelect={() => onToggleReportIssue(true)}
          size="sm"
          translationKey="FCT.REPORTING.HEADER.MENU.REPORT_ISSUE"
        />
      </MenuGroup>
    </Menu>
  );
}
